
import Vue from "vue";
import { v4 as uuid } from "uuid";
import { mapGetters, mapActions } from "vuex";
import color from "@/assets/plugins/formvalidation/src/js/validators/color";

interface Container {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  fill: string;
  stroke: string;
  strokeWidth: number;
  type: string;
  isReefer: boolean;
  is45Foot: boolean;
  isTank: boolean;
  isFlatRack: boolean;
  isOpenTop: boolean;
  isPlatform: boolean;
}

export default Vue.extend({
  inject: ["readonly"],
  props: {
    data: {
      type: Object as () => {
        cols: number;
        rows: number;
        cells: {
          existed: boolean;
          isReefer: boolean;
          is45Foot: boolean;
          isTank: boolean;
          isFlatRack: boolean;
          isOpenTop: boolean;
          isPlatform: boolean;
        }[];
      },
      default: () => ({
        cols: 5,
        rows: 5,
        cells: [
          {
            existed: true,
            isReefer: true,
            is45Foot: true,
            isTank: false,
            isFlatRack: false,
            isOpenTop: false,
            isPlatform: false,
          },
          {
            existed: false,
            isReefer: true,
            is45Foot: false,
            isTank: false,
            isFlatRack: false,
            isOpenTop: false,
            isPlatform: false,
          },
        ],
      }),
    },
    name: {
      type: String,
      default: "01",
    },
    VesselHatchId: {
      type: Number,
      default: 0,
    },
    VesselbayId: {
      type: Number,
      default: 0,
    },
    vesselBayType: {
      type: Number,
      default: 0,
    },
    bayType: {
      default: "",
      type: String,
    },
    minDeckTiersNo: { default: 0 },
    minHoldTiersNo: { default: 0 },
  },
  data() {
    return {
      ctrlKey: false,
      selectedCells: [],
      CELL_WIDTH: 20,
      SPACE_BETWEEN_CELLS: 0,
      // Upload images
      reeferImage:
        process.env.VUE_APP_BASE_URL + "media/svg/vesselProfile/Reefer.svg",
      hazardousImage:
        process.env.VUE_APP_BASE_URL +
        "media/svg/vesselMonitoring/hazardous.svg",
      highCubeImage:
        process.env.VUE_APP_BASE_URL +
        "media/svg/vesselMonitoring/highcube.svg",
      fortyFooterImage:
        process.env.VUE_APP_BASE_URL +
        "media/svg/vesselMonitoring/fortyfooter.svg",
      fortyFiveFooterImage:
        process.env.VUE_APP_BASE_URL +
        "media/svg/vesselMonitoring/fortyfivefooter.svg",

      // Tooltip
      stageSize: { width: 500, height: 500 },
      tooltipPosition: { x: 50, y: 50 },
      tooltipText: "Your tooltip text here",
      tooltipVisible: true,
      tooltipKey: 0,
      tooltipStyle: {}, // This will hold the position styles for the tooltip

      textConfig: {
        fontSize: 10,
        fill: "#000000",
      },
    };
  },
  methods: {
    ...mapActions([
      "setVesselMonitoringContainerDetailRequest",
      "setIsVesselMonitoringContainerDetailModalOpen",
    ]),
    onmousedown(c, index, evt) {
      if (
        !this.checkCanCellSelected(c, evt) &&
        !this.ctrlKey
      ) {
        return;
      } else {
        if (this.ctrlKey)
          this.selectCell(index);
        else {
          this.handleClick(index, this.bayType);
        }
      }
    },
    onmouseover(cell, evt) {
      this.$emit(
        "sendDataToParent",
        cell.stowageInstructionDetailId
      );
      if (this.getcurrentColorSlected) {
        document.body.style.cursor = "pointer";
        if (!this.ctrlKey)
          this.checkCanCellSelected(cell, evt);
      }
    },
    onmouseout(evt) {
      this.$emit("sendDataToParent", null);
    },
    onmouseup(index, evt) {
      this.EndSelectedIndexCell = index;
      if (this.ctrlKey)
        this.colorAndSelectCell();
    },
    selectCell(index) {
      if (this.selectedCells.length < 2) {
        this.selectedCells.push(index);
      } else {
        this.selectedCells = [index];
      }
    },
    onKeyPress(event) {
      if (event.ctrlKey) {
        this.ctrlKey = true;
      }
    },
    onkeyup(event) {
      this.ctrlKey = false;
      this.selectedCells = [];
    },
    handleCellClick(containerData) {
      this.setVesselMonitoringContainerDetailRequest({
        containerNo: containerData.containerNo,
        stowageInstructionDetailCellId:
          containerData.stowageInstructionDetailCellId,
      });
      this.setIsVesselMonitoringContainerDetailModalOpen(true);
    },
    checkCanCellSelected(cell, evt) {
      var result = true;
      this.getvoyageContainersList.details.forEach((element) => {

        if (
          element.stowageInstructionDetailId ==
          this.getcurrentStowage.stowageInstructionDetailId
        )
          
            //prevent counting same cell  selected before
            if (
              element.containerQuantity == element.stowageInstructionQuantity &&
              cell.stowageInstructionDetailId !=
              element.stowageInstructionDetailId
            ) {
              document.body.style.cursor = "not-allowed";
              result = false;
            }
          
          });
      if (this.getcurrentStowage.containerSizeId != 1 && !cell.hasBay40) {
        document.body.style.cursor = "not-allowed";
        result = false;
      }
      if (
        this.vesselBayType == 2 &&
        (cell.stowageInstructionIs4045Foot ||
          this.getcurrentStowage.containerSizeId != 1)
      ) {
        document.body.style.cursor = "not-allowed";
        result = false;
      }
      return result;
    },
    getXLabels() {
      if (this.bayType == "onDeck") {
        const labels: string[] = [];
        const middle =
          this.data.cols % 2 === 0
            ? this.data.cols / 2
            : Math.floor(this.data.cols / 2);
        const startNumber = this.data.cols % 2 === 0 ? 1 : 0;

        for (let i = 0; i < this.data.cols; i++) {
          if (this.data.cols % 2 === 0) {
            labels[middle + Math.floor((i * (-1) ** i) / 2)] = (i + 1)
              .toString()
              .padStart(2, "0");
          } else {
            labels[middle + Math.ceil((i * (-1) ** (i - 1)) / 2)] = (
              startNumber + i
            )
              .toString()
              .padStart(2, "0");
          }
        }

        return labels.filter((label) => label !== undefined);
      } else {
        let labels = [];
        let middle =
          this.data.cols % 2 === 0
            ? this.data.cols / 2
            : Math.floor(this.data.cols / 2);
        let startNumber = this.data.cols % 2 === 0 ? 1 : 0;
        for (let i = 0; i < this.data.cols; i++) {
          if (this.data.cols % 2 === 0) {
            labels[middle + Math.floor((i * (-1) ** i) / 2)] = (i + 1)
              .toString()
              .padStart(2, "0");
          } else {
            labels[middle + Math.ceil((i * (-1) ** (i - 1)) / 2)] = (
              startNumber + i
            )
              .toString()
              .padStart(2, "0");
          }
        }
        return labels;
      }
    },
    getYLabels() {
      const labels: (string | undefined)[] = [];
      if (this.bayType == "onDeck") {
        for (let i = this.data.rows - 1; i >= 0; i--) {
          labels.push((this.minDeckTiersNo + i * 2).toString());
        }
      } else {
        for (let i = this.data?.rows; i >= 0; i--) {
          labels.push(
            (this.minHoldTiersNo + i * 2).toString().padStart(2, "0")
          );
        }
      }
      return labels.filter((label) => label !== undefined) as string[];
    },
    getXLabelConfig(value: string, index: number) {
      if (this.bayType == "onDeck") {
        return {
          text: value,
          x: 65 + index * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS),
          y: 15,
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      } else {
        return {
          text: value,
          x: 65 + index * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS),
          y:
            25 + this.data?.rows * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS),
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      }
    },
    getYLabelConfig(value: string, index: number) {
      if (this.bayType == "onDeck") {
        return {
          text: value.toString(),
          x: this.data.cols * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS) + 70,
          y: 20 + this.CELL_WIDTH + index * this.CELL_WIDTH,
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      } else {
        return {
          text: value.toString(),
          x:
            this.data?.cols * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS) + 70,
          y: -5 + index * this.CELL_WIDTH,
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      }
    },
    getYLabelConfigLeft(value: string, index: number) {
      if (this.bayType == "onDeck") {
        return {
          text: value.toString(),
          x: 30,
          y: 5 + this.CELL_WIDTH + index * this.CELL_WIDTH,
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      } else {
        return {
          text: value.toString(),
          x: 30,
          y: -10 + index * this.CELL_WIDTH,
          fontSize: 11,
          listening: false,
          fill: "#707070",
        };
      }
    },
    handleClick(cellIndex: number) {
      if (this.readonly) return;
      if (this.getcurrentColorSlected) {
        this.updateCell(cellIndex);
      } else {
        alert("Please Select Stowage Instraction Row");
      }
    },
    updateCell(cellIndex) {
      this.toggleCellProperty2(
        this.VesselHatchId,
        this.VesselbayId,
        this.bayType,
        cellIndex,
        this.getcurrentColorSlected
      );
    },
    toggleCellProperty2(
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentValue
    ) {
      var currentStowageId = this.getcurrentStowage.stowageInstructionDetailId;
      var currentCellSelectd = this.getCurrentCellSelectd(
        VesselHatchId,
        VesselbayId,
        bayType,
        cellIndex
      );
      var currentStowageInstructionSelected = this.currentStowageInstructionSelected(
        currentStowageId
      );

      if (currentCellSelectd.stowageInstructionDetailId) {
        if (
          currentStowageInstructionSelected.stowageInstructionDetailId ==
          currentCellSelectd.stowageInstructionDetailId
        ) {
          this.removeStowageInCell(
            currentCellSelectd,
            currentStowageInstructionSelected,
            VesselHatchId,
            VesselbayId,
            bayType,
            cellIndex,
            currentValue,
            currentStowageId
          );
        } else {
          this.removeAndaddStowageInCell(
            currentCellSelectd,
            currentStowageInstructionSelected,
            VesselHatchId,
            VesselbayId,
            bayType,
            cellIndex,
            currentValue,
            currentStowageId
          );
        }
      } else {
        this.addStowageInCell(
          currentCellSelectd,
          currentStowageInstructionSelected,
          VesselHatchId,
          VesselbayId,
          bayType,
          cellIndex,
          currentValue,
          currentStowageId
        );
      }
    },
    getCurrentCellSelectd(VesselHatchId, VesselbayId, bayType, cellIndex) {
      var cell = this.getStowagInstructionResponse.data.vesselHatches[
        VesselHatchId
      ].vesselBays[VesselbayId]?.[bayType].cells[cellIndex];
      return cell;
    },
    currentStowageInstructionSelected(currentStowageId) {
      var result = this.getvoyageContainersList.details.find(
        (c) => c.stowageInstructionDetailId == currentStowageId
      );
      return result;
    },
    addStowageInCell(
      currentCellSelectd,
      StowageInstruction,
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentValue
    ) {
      StowageInstruction.stowageInstructionQuantity++;
      this.$store.dispatch("stowagtoggleCellProperty", {
        VesselHatchId,
        VesselbayId,
        bayType,
        cellIndex,
        currentStowageId: StowageInstruction.stowageInstructionDetailId,
        currentValue,
        stowageInstructionIs4045Foot:
          StowageInstruction.containerSizeId != 1 ? true : false,
      });

      if (
        this.vesselBayType == 1 &&
        StowageInstruction.containerSizeId != 1 &&
        currentCellSelectd.isInBay
      ) {
        var vesselbayId = VesselbayId == 0 ? 1 : 0;
        var anotherCellbay = this.getCurrentCellSelectd(
          VesselHatchId,
          vesselbayId,
          bayType,
          cellIndex
        );
        if (!anotherCellbay) return;
        if (!anotherCellbay.isInBay) {
          return;
        }
        //to do
        // check if on hold container is 20 foot
        this.$store.dispatch("stowagtoggleCellProperty", {
          VesselHatchId,
          VesselbayId: vesselbayId,
          bayType,
          cellIndex,
          currentStowageId: StowageInstruction.stowageInstructionDetailId,
          currentValue,
          stowageInstructionIs4045Foot: true,
        });
      } else {
      }
    },
    removeStowageInCell(
      currentCellSelectd,
      StowageInstruction,
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentValue
    ) {
      if (!StowageInstruction) return;
      StowageInstruction.stowageInstructionQuantity--;
      if (
        this.vesselBayType == 1 &&
        currentCellSelectd.stowageInstructionIs4045Foot &&
        currentCellSelectd.isInBay
      ) {
        var vesselbayId = VesselbayId == 0 ? 1 : 0;
        var cellInHoldBay = this.getCurrentCellSelectd(
          VesselHatchId,
          vesselbayId,
          bayType,
          cellIndex
        );
        if (cellInHoldBay && cellInHoldBay.isInBay) {
          this.$store.dispatch("stowagtoggleCellProperty", {
            VesselHatchId,
            VesselbayId: vesselbayId,
            bayType,
            cellIndex,
            currentStowageId: 0,
            currentValue: null,
            stowageInstructionIs4045Foot: false,
          });
        }
      }
      this.$store.dispatch("stowagtoggleCellProperty", {
        VesselHatchId,
        VesselbayId,
        bayType,
        cellIndex,
        currentStowageId: 0,
        currentValue: null,
        stowageInstructionIs4045Foot: false,
      });
    },
    removeAndaddStowageInCell(
      currentCellSelectd,
      currentStowageInstructionSelected,
      VesselHatchId,
      VesselbayId,
      bayType,
      cellIndex,
      currentValue,
      currentStowageId
    ) {
      var index = this.getvoyageContainersList.details.findIndex(
        (c) =>
          c.stowageInstructionDetailId ==
          currentCellSelectd.stowageInstructionDetailId
      );
      var lastCurrentStowageInstruction = this.getvoyageContainersList.details[
        index
      ];

      this.removeStowageInCell(
        currentCellSelectd,
        lastCurrentStowageInstruction,
        VesselHatchId,
        VesselbayId,
        bayType,
        cellIndex,
        currentValue
      );
      this.addStowageInCell(
        currentCellSelectd,
        currentStowageInstructionSelected,
        VesselHatchId,
        VesselbayId,
        bayType,
        cellIndex,
        currentValue,
        currentStowageId
      );
    },
    CellIsNotInBay(VesselHatchId, VesselbayId, bayType, cellIndex) { },
    isSelected(index) {
      const cols = this.data.cols;
      if (this.selectedCells.length < 2) return false;
      const [start, end] = this.selectedCells.sort((a, b) => a - b);
      var startRow = Math.floor(start / cols);
      var endRow = Math.floor(end / cols);
      var startCol = start % cols;
      var endCol = end % cols;
      const row = Math.floor(index / cols);
      const col = index % cols;
      if (startCol > endCol) {
        const temp = startCol;
        startCol = endCol;
        endCol = temp;
      }
      return (
        row >= startRow && row <= endRow && col >= startCol && col <= endCol
      );
    },
    colorAndSelectCell() {
      if (this.selectedCells.length < 2) return;
      var context = this;
      var indexs = [];
      var oneCellIsActive = false;
      var currentStowageId = this.getcurrentStowage.stowageInstructionDetailId;
      var cellSelectedWihtCurrentStowageInstruction = [];
      var CellEmptyIndexs = [];
      var cellSelectedWihtAnotherCurrentStowageInstruction = [];
      this.data.cells.forEach(function (value, index) {
        if (context.isSelected(index)) {
          indexs.push(index);
          if (value.stowageInstructionDetailId != 0) {
            oneCellIsActive = true;
          }
          if (value.stowageInstructionDetailId == 0) {
            CellEmptyIndexs.push(index);
          } else if (value.stowageInstructionDetailId != currentStowageId) {
            cellSelectedWihtAnotherCurrentStowageInstruction.push(index);
          } else {
            cellSelectedWihtCurrentStowageInstruction.push(index);
          }
        }
      });

      this.getvoyageContainersList.details.forEach((element) => {
        if (
          element.stowageInstructionDetailId ==
          this.getcurrentStowage.stowageInstructionDetailId
        ) {
          if (
            oneCellIsActive ||
            element.containerQuantity >=
            element.stowageInstructionQuantity + CellEmptyIndexs.length
          ) {
            if (oneCellIsActive) {
              cellSelectedWihtCurrentStowageInstruction.forEach((Cellindex) => {
                var currentCellSelectd = context.getCurrentCellSelectd(
                  context.VesselHatchId,
                  context.VesselbayId,
                  context.bayType,
                  Cellindex
                );
                var currentStowageInstructionSelected = context.currentStowageInstructionSelected(
                  currentStowageId
                );
                context.removeStowageInCell(
                  currentCellSelectd,
                  currentStowageInstructionSelected,
                  context.VesselHatchId,
                  context.VesselbayId,
                  context.bayType,
                  Cellindex,
                  context.getcurrentColorSlected,
                  currentStowageId
                );
              });
              cellSelectedWihtAnotherCurrentStowageInstruction.forEach(
                (Cellindex) => {
                  var currentCellSelectd = context.getCurrentCellSelectd(
                    context.VesselHatchId,
                    context.VesselbayId,
                    context.bayType,
                    Cellindex
                  );
                  var index = this.getvoyageContainersList.details.findIndex(
                    (c) =>
                      c.stowageInstructionDetailId ==
                      currentCellSelectd.stowageInstructionDetailId
                  );
                  var lastCurrentStowageInstruction = this
                    .getvoyageContainersList.details[index];
                  context.removeStowageInCell(
                    currentCellSelectd,
                    lastCurrentStowageInstruction,
                    context.VesselHatchId,
                    context.VesselbayId,
                    context.bayType,
                    Cellindex,
                    context.getcurrentColorSlected,
                    currentStowageId
                  );
                }
              );
            } else {
              indexs.forEach((Cellindex) => {
                var currentCellSelectd = context.getCurrentCellSelectd(
                  context.VesselHatchId,
                  context.VesselbayId,
                  context.bayType,
                  Cellindex
                );
                var currentStowageInstructionSelected = context.currentStowageInstructionSelected(
                  currentStowageId
                );
                context.removeAndaddStowageInCell(
                  currentCellSelectd,
                  currentStowageInstructionSelected,
                  context.VesselHatchId,
                  context.VesselbayId,
                  context.bayType,
                  Cellindex,
                  context.getcurrentColorSlected,
                  currentStowageId
                );
              });
            }
          } else {
            setTimeout(() => {
              alert(
                "The selected range is greater than stowage Instruction Quantity. "
              );
            }, 500);
          }
        }
      });
      this.selectedCells = [];
    },
  },
  computed: {
    ...mapGetters([
      "getvoyageContainersList",
      "getcurrentStowage",
      "getcurrentColorSlected",
      "getStowagInstructionResponse",
    ]),
    containers() {
      const thisComponentRef = this;
      const cols = thisComponentRef.data.cols;
      const rows = thisComponentRef.data.rows;
      let stroke = "#A0A0A0";
      let hoverStroke = "#000000";
      let strokeWidth = 0.3;
      let hoverStrokeWidth = 1;
      const newContainers = this.data.cells.map((c, index) => {
        let cellData = {};
        let fill =
          c.color === null
            ? "#fafafa"
            : `#${c.color.startsWith("#") ? c.color.substring(1) : c.color}`;
        if (c.isInBay) {
          cellData = {
            ...c,
            id: uuid(),
            index,
            x:
              this.bayType == "onDeck"
                ? (index % cols) *
                (thisComponentRef.CELL_WIDTH + this.SPACE_BETWEEN_CELLS) +
                50
                : (index % cols) * thisComponentRef.CELL_WIDTH + 50,
            y:
              this.bayType == "onDeck"
                ? (rows - 1 - Math.floor(index / cols)) *
                (thisComponentRef.CELL_WIDTH + 1) +
                20
                : (rows - 1 - Math.floor(index / cols)) *
                (thisComponentRef.CELL_WIDTH + 1) +
                5,
            width: thisComponentRef.CELL_WIDTH,
            height: thisComponentRef.CELL_WIDTH,
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            shadowColor: "black",
            shadowBlur: 0,
            shadowOffset: { x: 1, y: 1 },
            shadowOpacity: 0.5,
            type: "standard",
          };

          if (this.getcurrentStowage) {
            if (
              c.stowageInstructionDetailId ==
              this.getcurrentStowage.stowageInstructionDetailId
            ) {
              cellData = {
                ...cellData,
                strokeWidth: 2,
                stroke: "#181c32",
                shadowBlur: 1,
                scaleX: 0.94,
                scaleY: 0.94,
              };
            }
            else if (c.stowageInstructionDetailId) {
              cellData = {
                ...cellData,
                strokeWidth: 1,
                opacity: 0.3
              }
            }
          }
        }        
        return cellData;
      });
      return newContainers;
    },
    getWith() {
      return 100 + this.data.cols * this.CELL_WIDTH;
    },
    getHeight() {
      return this.data.rows * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS) + 50;
    }
  },
  created() {
    document.addEventListener("keydown", this.onKeyPress);
    document.addEventListener("keyup", this.onkeyup);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyPress);
    document.removeEventListener("keyup", this.onkeyup);
  },
});
